webpackJsonp([147781930364240],{

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forms = __webpack_require__(36);
	
	var _components = __webpack_require__(3);
	
	var _Paths = __webpack_require__(14);
	
	var Paths = _interopRequireWildcard(_Paths);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterPage = function (_React$Component) {
	  _inherits(RegisterPage, _React$Component);
	
	  function RegisterPage(props) {
	    _classCallCheck(this, RegisterPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  RegisterPage.prototype.componentDidMount = function componentDidMount() {
	    (0, _utils.seoPageChange)();
	  };
	
	  RegisterPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "RegisterPage grid-row grid-column v-align h-align full-height" },
	      _react2.default.createElement(_components.StripeBG, null),
	      _react2.default.createElement(
	        _components.PageAnimator,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "form form-page" },
	          _react2.default.createElement(
	            "div",
	            { className: "f1 t-center f-strong f-subdued s8" },
	            "New Account"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "login-form s6" },
	            _react2.default.createElement(_forms.RegisterForm, { onSuccess: function onSuccess(user) {
	                return (0, _gatsbyLink.navigateTo)(Paths.DB_USER_HOME);
	              } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "s1" },
	            _react2.default.createElement(
	              _components.Link,
	              { href: "/account/login", className: "f4" },
	              _react2.default.createElement("span", { className: "pt-icon-standard pt-icon-arrow-left" }),
	              "Back to login"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return RegisterPage;
	}(_react2.default.Component);
	
	exports.default = RegisterPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-account-register-js-1dbe9c05b8c8ab201f34.js